// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-grid[data-v-54fa14c4]{gap:0 1.5rem}.product-grid-item[data-v-54fa14c4]{padding-bottom:40px}[data-v-54fa14c4] .card-audio{height:80px;margin-bottom:.5rem !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
